import { format } from 'date-fns';
import React, { ChangeEvent, useRef } from 'react';
import { Form, FormInputProps, Icon, Label } from 'semantic-ui-react';

type DateInputProps = Omit<FormInputProps, 'onChange'> & {
  value?: Date;
  label?: string | React.ReactNode;
  onChange?: (date: Date) => void;
  'data-testid'?: string;
};

export default function DateInput({
  value,
  label,
  'data-testid': dataTestId,
  onChange,
  ...rest
}: DateInputProps) {
  const inputRef = useRef<HTMLInputElement>(null);
  const showPicker = () => {
    inputRef.current?.showPicker();
  };
  return (
    <Form.Input
      type="date"
      className="date"
      labelPosition="left"
      value={value ? format(value, 'yyyy-MM-dd') : ''}
      onChange={(event: ChangeEvent<HTMLInputElement>) => onChange?.(event.target.valueAsDate)}
      {...rest}
    >
      <Label onClick={showPicker}>
        <Icon fitted name="calendar alternate outline" />
        {label && ' '} {label}
      </Label>

      <input data-testid={dataTestId} ref={inputRef} />
    </Form.Input>
  );
}
